var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleCProDndIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.2143C8.5 18.9244 9.05964 19.5 9.75 19.5C10.4404 19.5 11 18.9244 11 18.2143C11 17.5042 10.4404 16.9286 9.75 16.9286C9.05964 16.9286 8.5 17.5042 8.5 18.2143Z",
    fill: "#8493B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.2143C1 18.9244 1.55964 19.5 2.25 19.5C2.94036 19.5 3.5 18.9244 3.5 18.2143C3.5 17.5042 2.94036 16.9286 2.25 16.9286C1.55964 16.9286 1 17.5042 1 18.2143Z",
    fill: "#8493B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.5C8.5 11.2101 9.05964 11.7857 9.75 11.7857C10.4404 11.7857 11 11.2101 11 10.5C11 9.78992 10.4404 9.21429 9.75 9.21429C9.05964 9.21429 8.5 9.78992 8.5 10.5Z",
    fill: "#8493B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5C1 11.2101 1.55964 11.7857 2.25 11.7857C2.94036 11.7857 3.5 11.2101 3.5 10.5C3.5 9.78992 2.94036 9.21429 2.25 9.21429C1.55964 9.21429 1 9.78992 1 10.5Z",
    fill: "#8493B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.78571C8.5 3.49579 9.05964 4.07143 9.75 4.07143C10.4404 4.07143 11 3.49579 11 2.78571C11 2.07563 10.4404 1.5 9.75 1.5C9.05964 1.5 8.5 2.07563 8.5 2.78571Z",
    fill: "#8493B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.78571C1 3.49579 1.55964 4.07143 2.25 4.07143C2.94036 4.07143 3.5 3.49579 3.5 2.78571C3.5 2.07563 2.94036 1.5 2.25 1.5C1.55964 1.5 1 2.07563 1 2.78571Z",
    fill: "#8493B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.2143C8.5 18.9244 9.05964 19.5 9.75 19.5C10.4404 19.5 11 18.9244 11 18.2143C11 17.5042 10.4404 16.9286 9.75 16.9286C9.05964 16.9286 8.5 17.5042 8.5 18.2143Z",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.2143C1 18.9244 1.55964 19.5 2.25 19.5C2.94036 19.5 3.5 18.9244 3.5 18.2143C3.5 17.5042 2.94036 16.9286 2.25 16.9286C1.55964 16.9286 1 17.5042 1 18.2143Z",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.5C8.5 11.2101 9.05964 11.7857 9.75 11.7857C10.4404 11.7857 11 11.2101 11 10.5C11 9.78992 10.4404 9.21429 9.75 9.21429C9.05964 9.21429 8.5 9.78992 8.5 10.5Z",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5C1 11.2101 1.55964 11.7857 2.25 11.7857C2.94036 11.7857 3.5 11.2101 3.5 10.5C3.5 9.78992 2.94036 9.21429 2.25 9.21429C1.55964 9.21429 1 9.78992 1 10.5Z",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.78571C8.5 3.49579 9.05964 4.07143 9.75 4.07143C10.4404 4.07143 11 3.49579 11 2.78571C11 2.07563 10.4404 1.5 9.75 1.5C9.05964 1.5 8.5 2.07563 8.5 2.78571Z",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.78571C1 3.49579 1.55964 4.07143 2.25 4.07143C2.94036 4.07143 3.5 3.49579 3.5 2.78571C3.5 2.07563 2.94036 1.5 2.25 1.5C1.55964 1.5 1 2.07563 1 2.78571Z",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleCProDndIcon);
export default __webpack_public_path__ + "static/media/singleCProDndIcon.72bfc766b1c5c31e1045dbfa060e4b64.svg";
export { ForwardRef as ReactComponent };